var _defs, _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRainy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "blur",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    slope: 0.05,
    type: "linear"
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("style", null, "@keyframes am-weather-sun{0%{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes am-weather-rain{0%{stroke-dashoffset:0}to{stroke-dashoffset:-100}}"))), /*#__PURE__*/React.createElement("g", {
    id: "rainy-1",
    filter: "url(#blur)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2 0 0 1.2 20 26)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      WebkitAnimationName: "am-weather-sun",
      MozAnimationName: "am-weather-sun",
      msAnimationName: "am-weather-sun",
      animationName: "am-weather-sun",
      WebkitAnimationDuration: "9s",
      MozAnimationDuration: "9s",
      msAnimationDuration: "9s",
      animationDuration: "9s",
      WebkitAnimationTimingFunction: "linear",
      MozAnimationTimingFunction: "linear",
      msAnimationTimingFunction: "linear",
      animationTimingFunction: "linear",
      WebkitAnimationIterationCount: "infinite",
      MozAnimationIterationCount: "infinite",
      msAnimationIterationCount: "infinite",
      animationIterationCount: "infinite"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "orange",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M0 9v3M-6.364 6.364l-2.121 2.121M-9 0h-3M-6.364-6.364l-2.121-2.121M0-9v-3M6.364-6.364l2.121-2.121M9 0h3M6.364 6.364l2.121 2.121"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "orange",
    stroke: "orange",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#57A0EE",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.275,
    d: "M45.545 35.09c0-3.91-3.145-6.97-6.97-6.97-.85 0-1.615.17-2.38.425-.255-2.89-2.635-5.27-5.61-5.27a5.695 5.695 0 0 0-5.695 5.695c0 .68.17 1.36.34 1.955-.255-.085-.595-.085-.85-.085a5.695 5.695 0 0 0-5.695 5.695c0 3.06 2.465 5.61 5.525 5.695h14.62c3.74-.425 6.715-3.4 6.715-7.14z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#91C0F8",
    strokeDasharray: "4,7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M0 0v8",
    style: {
      WebkitAnimationName: "am-weather-rain",
      MozAnimationName: "am-weather-rain",
      msAnimationName: "am-weather-rain",
      animationName: "am-weather-rain",
      WebkitAnimationDuration: "8s",
      MozAnimationDuration: "8s",
      msAnimationDuration: "8s",
      animationDuration: "8s",
      WebkitAnimationTimingFunction: "linear",
      MozAnimationTimingFunction: "linear",
      msAnimationTimingFunction: "linear",
      animationTimingFunction: "linear",
      WebkitAnimationIterationCount: "infinite",
      MozAnimationIterationCount: "infinite",
      msAnimationIterationCount: "infinite",
      animationIterationCount: "infinite"
    },
    transform: "rotate(10 -248.606 182.52)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#91C0F8",
    strokeDasharray: "4,7",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M0 0v8",
    style: {
      WebkitAnimationName: "am-weather-rain",
      MozAnimationName: "am-weather-rain",
      msAnimationName: "am-weather-rain",
      animationName: "am-weather-rain",
      WebkitAnimationDelay: ".25s",
      MozAnimationDelay: ".25s",
      msAnimationDelay: ".25s",
      animationDelay: ".25s",
      WebkitAnimationDuration: "8s",
      MozAnimationDuration: "8s",
      msAnimationDuration: "8s",
      animationDuration: "8s",
      WebkitAnimationTimingFunction: "linear",
      MozAnimationTimingFunction: "linear",
      msAnimationTimingFunction: "linear",
      animationTimingFunction: "linear",
      WebkitAnimationIterationCount: "infinite",
      MozAnimationIterationCount: "infinite",
      msAnimationIterationCount: "infinite",
      animationIterationCount: "infinite"
    },
    transform: "rotate(10 -240.176 217.81)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy1);
export default __webpack_public_path__ + "static/media/rainy-1.556656461f6609e5534788e94acc51c9.svg";
export { ForwardRef as ReactComponent };